import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  BackendResponse,
  DashboardTileDataset,
  DashboardTiles,
  Menu,
} from '@qtek/shared/models';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private http = inject(HttpClient);

  private baseRequestOptions = {
    withCredentials: true,
  };

  /**
   * Send request to get main menu of application.
   *
   * @returns {Observable<BackendResponse<Menu>>} Return array of menu entries.
   *
   * @memberof MenuService
   */
  getMainMenu(): Observable<BackendResponse<Menu>> {
    return this.http.get<BackendResponse<Menu>>(
      '/api/v2/config/appmenu',
      this.baseRequestOptions
    );
  }

  /**
   * Send request to get setup module.
   *
   * @returns {Observable<BackendResponse<Menu>>} Return array of menu entries.
   *
   * @memberof MenuService
   */
  getSetupMenu(): Observable<BackendResponse<Menu>> {
    return this.http.get<BackendResponse<Menu>>(
      '/api/v2/config/stp',
      this.baseRequestOptions
    );
  }

  /**
   * Send request to get dashboard module.
   *
   * @returns {Observable<BackendResponse<Menu>>} Return array of menu entries.
   *
   * @memberof MenuService
   */
  getDashboardMenu(): Observable<DashboardTiles> {
    return this.http.get<DashboardTiles>(
      `/api/v2/dashboard`,
      this.baseRequestOptions
    );
  }

  /**
   * Send request to get datasets for a dashboard tile.
   *
   * @param {string} datasetType Tile `datasource.type`.
   * @returns {Observable<BackendResponse<{ data: DashboardTileDataset[] }>>}
   *
   * @memberof MenuService
   */
  getReportDataset(
    datasetType: string
  ): Observable<BackendResponse<{ data: DashboardTileDataset[] }>> {
    return this.http.get<BackendResponse<{ data: DashboardTileDataset[] }>>(
      `/api/v2/report/dataset/${datasetType}`,
      this.baseRequestOptions
    );
  }
}
